<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-社会就业课程-添加
    -->
    <el-dialog
    title="添加社会就业课程"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加社会就业课程</div>
      
      <el-form-item label="社会就业课程名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入社会就业课程名称" class="max-w460"></el-input>
      </el-form-item>
      
      <el-form-item label="兼职名称" prop="stage_stage_id">
        <el-select v-model="form.stage_stage_id" placeholder="请选择兼职名称" class="max-w460">
            <template v-for="jz in jzList">
              <el-option :value="jz.stage_stage_id" :key="jz.stage_stage_id" :label="jz.name"></el-option>
            </template>
        </el-select>
      </el-form-item>
      
      <!-- 图片上传区域 -->
      <el-form-item label="视频" prop="image">
        <div class="draggable-list">
          <draggable class="wrapper" v-model="form.image">
            <transition-group>
              <div v-for="(item, index) in form.image" :key="item.file_id || index">
                <div class="item">
                  <img v-img-url="item.file_path" alt="课程图片预览"/>
                  <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteFile(index, 'album')">
                    <i class="el-icon-close"></i>
                  </a>
                </div>
              </div>
            </transition-group>
          </draggable>
          <div class="item img-select" @click="openProductUpload('album')">
            <i class="el-icon-plus"></i>
          </div>
        </div>
       
      </el-form-item>
      
      <el-form-item label="排序" prop="sort">
        <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
      </el-form-item>
       
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    
    <!-- 文件上传组件 -->
    <Upload 
      v-if="isProductUpload" 
      :config="{ 
        total: 9, 
        accept: 'image/*',
        size: 10485760  // 10MB
      }" 
      :isupload="isProductUpload" 
      @returnImgs="returnProductImgsFunc"
      @close="isProductUpload = false"
    >
      上传图片
    </Upload>
  </div>
</el-dialog>
  
</template>

<script>
import Course_courseApi from '@/api/course_course.js';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';

export default {
  components: {
    Upload,
    Categoryas,
    draggable,
    Uediter
  },
  data() {
    return {
      /*是否上传图片*/
      isProductUpload: false,
      code: "album",
      
      /*form表单数据*/
      form: {
        stage_stage_id: '',
        name: '',
        code: 'custom',
        image: [],       // 图片列表
        sort: 50
      },
      
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入社会就业课程名称', trigger: 'blur' }],
        stage_stage_id: [{ required: true, message: '请选择兼职名称', trigger: 'change' }],
        image: [{ required: true, message: '请上传课程图片', trigger: 'change' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }]
      },
      
      jzList: [],
      dialogVisible: false,
      iscategorya: false,
      excludeIds: []
    };
  },
  
  created() {
    this.dialogVisible = this.open_add;
    this.getJzList();
  },
  
  props: ["open_add"],
  
  methods: {
    // 获取兼职列表
    getJzList() {
      Course_courseApi.getJzList()
        .then(res => {
          if (res && res.data && res.data.data) {
            this.jzList = res.data.data;
          } else {
            this.$message.error('获取兼职列表失败');
            this.jzList = [];
          }
        })
        .catch(error => {
          console.error('获取兼职列表出错:', error);
          this.$message.error('获取兼职列表失败，请稍后重试');
        });
    },

    chooseCategory() {
      this.iscategorya = true;
    },

    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", { openDialog: false, "type": "" });
    },
    
    // 取消操作
    cancelFunc() {
      this.dialogFormVisible("error");
    },

    // 提交表单
    onSubmit() {
      let self = this;
      let form = self.form;
      
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Course_courseApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg || '添加成功',
                type: 'success'
              });
              self.dialogFormVisible("success");
            })
            .catch(error => {
              self.loading = false;
              self.$message.error('添加失败: ' + (error.message || '网络错误'));
              console.error('添加失败:', error);
            });
        }
      });
    },

    /*打开上传窗口*/
    openProductUpload(code) {
      this.isProductUpload = true;
      this.code = code;
    },

    /*处理上传的图片*/
    returnProductImgsFunc(files) {
      if (!files || files.length === 0) {
        this.isProductUpload = false;
        return;
      }
      
      // 验证图片类型
      const isValid = this.validateImages(files);
      if (!isValid) {
        return;
      }
      
      // 添加到图片列表
      const imgs = this.form.image.concat(files);
      this.$set(this.form, "image", imgs);
      
      this.isProductUpload = false;
    },

    /*验证图片类型和大小*/
    validateImages(files) {
      // 图片允许的格式
      const imgTypes = ["bmp", "jpg", "jpeg", "png", "gif"];
      
      for (const file of files) {
        // 获取文件扩展名
        const ext = this.getFileExtension(file.file_path).toLowerCase();
        // 验证文件类型
        if (!imgTypes.includes(ext)) {
          this.$message.error("图片类型有误，请选择bmp、jpg、jpeg、png、gif格式");
          return false;
        }
        
        // 验证文件大小
        if (file.size && file.size > 10485760) { // 10MB
          this.$message.error("图片大小不能超过10MB");
          return false;
        }
      }
      
      return true;
    },

    /*删除图片*/
    deleteFile(index, code) {
      if (code === 'album') {
        this.form.image.splice(index, 1);
      }
    },

    /*获取文件扩展名*/
    getFileExtension(filePath) {
      if (!filePath) return '';
      const arr = filePath.split(".");
      return arr.length > 1 ? arr.pop() : '';
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 300px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
  text-align: center;
  cursor: pointer;
  z-index: 10;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
  cursor: pointer;
}

.draggable-list .img-select i {
  color: #409eff;
}

/* 表单提示信息 */
.form-hint {
  margin-top: 5px;
  font-size: 12px;
  color: #8392a5;
}
</style>
    


// WEBPACK FOOTER //
// src/views/plus/course_course/index/part/add.vue